import React, { useEffect, useState } from "react";
import { Button, Checkbox, Table, Modal, Input, message, Select } from "antd";
import AxiosInstance from "../../../../AxiosInstance";
import {
  amountFormat,
  getAmountFilterType,
  getYearFilterType,
  obj2url,
} from "../../../../utils";
import InvestorView from "./InvestorView";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Controller } from "react-hook-form";

export default function PartnerRecommendPolicyView() {
  const [loading, setLoading] = useState(true);
  const [paginationMetaData, setPaginationMetaData] = useState({});
  const [dataSource, setDataSource] = useState([]);
  const [selectedPolicies, setSelectedPolicies] = useState([]);
  const [currentState, setCurrentState] = useState("CREATE");
  const [response, setResponse] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [portfolioName, setPortfolioName] = useState("");
  const navigate = useNavigate();
  const [filterData, setFilterData] = useState({
    minTenure: null,
    maxTenure: null,
  });
  const updateFilter = (data) => {
    var old = filterData;
    old = { ...old, ...data };
    setFilterData(old);
    console.log(data);
    getTableData(0, old);
  };

  const isPolicySelected = (policyNumber) => {
    return selectedPolicies.includes(policyNumber);
  };

  const togglePolicySelection = (policyNumber) => {
    setSelectedPolicies((prevSelected) =>
      prevSelected.includes(policyNumber)
        ? prevSelected.filter((num) => num !== policyNumber)
        : [...prevSelected, policyNumber]
    );
  };

  useEffect(() => {
    getTableData(0, filterData);
  }, [filterData]);

  const getTableData = async (skip, filter = {}) => {
    const url =
      `policy/marketplace/list?take=10&skip=${skip}&isMatured=false&status=APPLIED` +
      obj2url(filter);
    AxiosInstance()
      .get(url)
      .then((resp) => {
        const { data } = resp;
        setDataSource(data.data);
        setPaginationMetaData(data.paginationMetaData);
        setLoading(false);
      })
      .catch((err) => {});
  };

  const createPortofolio = () => {
    if (!portfolioName.trim()) {
      return;
    }
    const data = {
      totalInvestment: 0,
      totalFundAmount: 0,
      totalLiquidationAmount: 0,
      totalTentativeAmount: 0,
      totalBudget: 0,
      averageIrr: 0,
      policies: selectedPolicies,
      portfolioName,
    };
    const url = `/portfolio`;
    AxiosInstance()
      .post(url, data)
      .then((resp) => {
        const { data } = resp;
        setCurrentState("SEND");
        setResponse(data);
        setIsModalVisible(false);
      })
      .catch((err) => {
        message.error(err.response.data.message);
      });
  };

  const columns = [
    {
      title: "Action",
      align: "center",
      render: (text, policy) => (
        <Checkbox
          checked={isPolicySelected(policy.policyId)}
          onChange={() => togglePolicySelection(policy.policyId)}
        />
      ),
    },
    {
      title: "Insurer",
      dataIndex: "insurerLogo",
      key: "insurerLogo",
      render: (text, policy) => (
        <img
          className="insurer-logo"
          alt="insurerlogo"
          src={policy.insurer.logo}
        />
      ),
    },
    {
      title: "Policy Type",
      dataIndex: "policy",
      key: "policy",
      align: "center",
      render: (text, policy) => <>{policy.product.productType}</>,
    },
    {
      title: "₹ Investment Amount",
      dataIndex: "investmentAmount",
      key: "investmentAmount",
      align: "right",
      render: (text) => <>{amountFormat(text)}</>,
    },
    {
      title: "₹ Liquidation Value (Tentative)",
      dataIndex: "liquidationAmount",
      key: "liquidationAmount",
      align: "right",
      render: (text) => <>{text ? amountFormat(text) : "N/A"}</>,
    },
    {
      title: "₹ Liquidation Eligible Date",
      dataIndex: "liquidationDate",
      key: "liquidationDate",
      align: "center",
      render: (text) => (text ? moment(text).format("DD/MM/YYYY") : "N/A"),
    },
    {
      title: "Investment Tenure",
      dataIndex: "investmentTenure",
      align: "center",
      key: "investmentTenure",
    },
    {
      title: "ROI",
      dataIndex: "roiPercentage",
      key: "roiPercentage",
      align: "center",
      render: (text) => (text ? parseFloat(text).toFixed(1) + " %" : "N/A"),
    },
  ];

  const change = (data) => {
    getTableData((data - 1) * 10);
  };

  return currentState === "CREATE" ? (
    <>
      <div className="d-flex gap-2 flex-sm-row flex-column justify-content-between">
        <div className="mx-2">
          {" "}
          <div className="col p-0">
            <button
              className="refer-policy-partner-btn"
              disabled={selectedPolicies.length === 0}
              onClick={() => setIsModalVisible(true)}
            >
              <i className="fa-solid fa-share tre_flex-hcenter text-white back-icon "></i>{" "}
              Refer Policies
            </button>
          </div>
          {/* <button
            className="add-policys "
            disabled={selectedPolicies.length === 0}
            onClick={() => setIsModalVisible(true)}
          >
            {" "}
            <i class="fa-solid fa-plus tre_flex-hcenter text-white policy-icon "></i>{" "}
            Refer Policies
          </button> */}
          {/* <Button
            className=""
            disabled={selectedPolicies.length === 0}
            onClick={() => setIsModalVisible(true)}
          >
            Refer Policies
          </Button>{" "} */}
        </div>
        <div className="d-flex gap-2">
          {" "}
          <div className="">
            <Select
              size="middle"
              className="p-0"
              // className={`${
              //   errors.accountType ? "is-invalid" : ""
              // }`}
              // value={getValues("accountType")}
              placeholder="Inv. Amount"
              onChange={(value) => {
                updateFilter(JSON.parse(value).data);
              }}
              // size="large"
              style={{ width: "100%" }}
            >
              {getAmountFilterType()}
            </Select>
          </div>
          <div className="">
            <Select
              className="p-0"
              // className={`${
              //   errors.accountType ? "is-invalid" : ""
              // }`}
              // value={getValues("accountType")}
              placeholder="Inv. Tenure"
              onChange={(value) => {
                updateFilter(JSON.parse(value).data);
              }}
              size="middle"
              style={{ width: "100%" }}
            >
              {getYearFilterType()}
            </Select>
          </div>
        </div>
      </div>
      <Table
        bordered={true}
        scroll={{ x: 400 }}
        loading={loading}
        className="table"
        dataSource={[...dataSource]}
        columns={columns}
        pagination={{
          pageSize: 10,
          total: paginationMetaData.count,
          onChange: change,
        }}
      />

      {/* Modal */}
      <Modal
        title="Portfolio Name"
        visible={isModalVisible}
        onOk={createPortofolio}
        onCancel={() => setIsModalVisible(false)}
        okButtonProps={{ disabled: !portfolioName.trim() }}
      >
        <Input
          placeholder="Enter Portfolio Name"
          value={portfolioName}
          onChange={(e) => setPortfolioName(e.target.value)}
        />
      </Modal>
    </>
  ) : (
    <InvestorView data={response} />
  );
}
